import Api from 'api/api';
import { queryKeys } from 'api/queryKeys';

export const userAgreements = {
  queryKey: queryKeys.userAgreements,
  queryFn: Api.getAgreements,
};
